module.exports = __webpack_public_path__ + "img/timer.28d05698.svg";